import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import Home from './pages/home/index';
import Words from './pages/words/index';
import Case from './pages/case/index';
import Trends from './pages/trends/index';
import TrendInfo from './pages/trendInfo/index';
import Feedback from "./pages/feedback/index";
import reportWebVitals from './reportWebVitals';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import './index.css';

const reducer = (state, action) => {
  if (!state) {
    return {
      close_header_message: false,
      header_message_data: {},
      user_info_data: {},
      words_info_data: {},//文档内容
      news_info_data: {},//新闻列表
      words_info_list: {},//文档列表
      last_word_content: "",
      home_case_data: {}
    }
  }
  switch (action.type) {
    case 'CLOSE_HEADER_MESSAGE':
      return {
        ...state,
        close_header_message: action.close_header_message
      }
    case 'SAVE_HEADER_MESSAGE_DATA':
      return {
        ...state,
        header_message_data: action.header_message_data
      }
    case 'SAVE_USER_INFO_DATA':
      return {
        ...state,
        user_info_data: action.user_info_data
      }
    case 'SAVE_WORDS_INFO_DATA':
      return {
        ...state,
        words_info_data: action.words_info_data
      }
    case 'SAVE_LAST_WORD_CONTENT':
      return {
        ...state,
        last_word_content: action.last_word_content
      }
    case 'SAVE_NEWS_INFO_DATA':
      return {
        ...state,
        news_info_data: action.news_info_data
      }
    case 'SAVE_WORDS_INFO_LIST':
      return {
        ...state,
        words_info_list: action.words_info_list
      }
    case 'SAVE_HOME_CASE_DATA':
      return {
        ...state,
        home_case_data: action.home_case_data
      }
  }
}
const store = createStore(reducer);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Switch>
        <Route exact path={'/words/:md_id'} component={Words} >
        </Route>
        <Route exact path={'/case'} component={Case} >
        </Route>
        <Route exact path={'/trends'} component={Trends} >
        </Route>
        <Route exact path={'/trendinfo/:id'} component={TrendInfo} >
        </Route>
        <Route exact path={'/feedback'} component={Feedback} >
        </Route>
        <Route exact path={'/'} component={Home} >
        </Route>
      </Switch>
    </Router>
  </Provider>,
  document.getElementById('root')
);

reportWebVitals();
